const LINKWIZ_EMAIL_DOMAIN = 'linkwiz.co.jp';

export const isLinkwizEmployeeEmail = (email: unknown): boolean => {
  if (typeof email !== 'string') {
    return false;
  }

  const normalizedEmail = email.replace(/^[\x09-\x0D\x20]+|[\x09-\x0D\x20]+$/g, '');
  if (!/^[\x21-\x7E]+$/.test(normalizedEmail)) {
    return false;
  }

  const parts = normalizedEmail.split('@');
  if (parts.length !== 2) {
    return false;
  }

  const [localPart, domain] = parts;
  return (
    localPart.length > 0 &&
    !/[<>]/.test(localPart) &&
    domain.length > 0 &&
    /^[A-Za-z0-9.-]+$/.test(domain) &&
    domain.toLowerCase() === LINKWIZ_EMAIL_DOMAIN
  );
};
